module.exports = __webpack_public_path__ + "static/media/avatars_all_30.52e3beac.png";